import { SafePromise } from '@benzinga/safe-await';
import { proxyClientOptions, RestfulClient, Session } from '@benzinga/session';
import { MoversResponse, MoversQuery } from './entities';
import { MoversEnvironment } from './environment';
import { moversRoutes } from './routes';

export class MoversRestful extends RestfulClient {
  constructor(session: Session) {
    const env = session.getEnvironment(MoversEnvironment);
    super(env.url, session, { 'x-device-key': false }, proxyClientOptions(undefined, 'apikey'));
  }

  getMovers = (query: MoversQuery): SafePromise<MoversResponse> => {
    const env = this.session.getEnvironment(MoversEnvironment);
    const params: MoversQuery = Object.assign(query);
    if (query.screenerQuery && typeof query.screenerQuery === 'object') {
      params.screenerQuery = this.buildScreenerQuery(
        query?.screenerQuery as Record<string, string | number | boolean | (number | string | boolean)[]>,
      );
    }
    if (query.moversQuery && typeof query.moversQuery === 'object') {
      params.moversQuery = this.buildScreenerQuery(
        query?.moversQuery as Record<string, string | number | boolean | (number | string | boolean)[]>,
      );
    }
    const path = this.routePath(moversRoutes.movers);
    const url = this.URL(path, this.withUpstreamCredentials(params, { apikey: env.key }));
    return this.get(url, {
      allowsAnonymousAuth: true,
      credentials: 'same-origin',
      includeHeader: { authorizationSession: true },
    });
  };

  buildScreenerQuery(
    screenerQuery: Record<string, number | string | boolean | (number | string | boolean)[]>,
  ): string | undefined {
    const screenerQueryParams = Object.keys(screenerQuery)
      .filter(key => screenerQuery[key])
      .map((key: string) => {
        const val = screenerQuery[key];
        const value = Array.isArray(val) ? (val as (number | string | boolean)[]).join(',') : val;
        return `${key}_${value}`;
      });
    return screenerQueryParams.join(';') || undefined;
  }
}
